module.exports = __webpack_public_path__ + "img/badge_buoni_main_level.f9d95caf.jpg";